import { Component, OnInit } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import { StorageManager } from "src/app/common/storage-manager.class";
import { SelectItem, MessageService } from "primeng/api";
import { Location } from "@angular/common";
import { UsersService } from "src/app/services/users/users.service";
import { Router, ActivatedRoute } from "@angular/router";
import { informes } from "src/app/config/models";
import { rellenarMenUsuario } from "src/app/config/procedimientos_registros";
import { url } from "src/app/config/config";
import { User } from "src/app/models/user-model";
import { GenericService } from "src/app/services/generic/generic.service";

@Component({
  selector: "app-usuario-create",
  templateUrl: "./usuario-create.component.html",
  styleUrls: ["./usuario-create.component.css"],
  providers: [UsersService],
})
export class usuarioCreateComponent implements OnInit {
  public variedades: SelectItem[];
  public date2: Date;
  public es: any;
  public createusuarioForm: UntypedFormGroup;
  public user: any;
  public selectedVariedad: any;
  public file: File;
  public imagePath;
  public imgURL: any;
  public message: string;
  //public listDocuments: informes[] = rellenarMenUsuario();
  public listDocuments: informes[] = [];
  myId: any;
  paramId: any;

  public url: string = "";
  public defaulturl: string =
    "https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com";
  update: boolean;

  listProveedores: any[] = [];

  constructor(
    private genericService: GenericService,
    private usuarioService: UsersService,
    private location: Location,
    public messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    // console.log(this.listDocuments);

    this.user = StorageManager.getUser();
  }

  ngOnInit() {
    this.es = {
      firstDayOfWeek: 1,
      dayNames: [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ],
      monthNamesShort: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic",
      ],
      today: "Hoy",
      clear: "Borrar",
    };

    this.user = StorageManager.getUser();
    this.FormUsuarios(null);
    this.route.params.subscribe((data) => {
      if (data.id != null) {
        this.update = true;
        this.paramId = data.id;
        this.myId = data.id;
        this.usuarioService
          .getUserId(this.myId)
          .toPromise()
          .then((usuario: User) => {
            if(usuario[0].role ==  "proveedor"){
              this.myId = usuario[0].id_proveedor;
            }
            this.FormUsuarios(usuario[0]);
          });
      }
    });
  }
  FormUsuarios(user) {
    if (user == null) {
      this.createusuarioForm = new UntypedFormGroup({
        nombre: new UntypedFormControl("", Validators.required),
        password: new UntypedFormControl("", Validators.required),
        role: new UntypedFormControl("proveedor"),
        read_only: new UntypedFormControl(false),
        eliminado: new UntypedFormControl(false),
        documentos: new UntypedFormGroup({}),
        responsable: new UntypedFormControl(this.user.name),
      });

      for (let index = 0; index < this.listDocuments.length; index++) {
        const element = this.listDocuments[index]["id"];
        let document = this.createusuarioForm.get(
          "documentos"
        ) as UntypedFormGroup;

        if (document.contains(element) == false) {
          document.addControl(element, new UntypedFormControl(false));
        }
      }
    } else {
      this.createusuarioForm.patchValue({
        nombre: user.nombre,
        password: user.password,
        role: user.role,
        observaciones: user.observaciones,
        read_only: user.read_only == "1" || user.read_only == 1 ? true : false,
        eliminado: user.eliminado == "1" || user.eliminado == 1 ? false : true
      });

      if (user.firma == undefined || user.firma.length == 0) {
        this.url = null;
        this.imgURL = null;
      } else {
        this.url = url + "upload/firmas/" + user.firma;
        this.imgURL = url + "upload/firmas/" + user.firma;
      }

      if (user.nombre == "Admin") {
      } else {
        let arrayDocumentos = user.documentos.split(";");

        for (let index = 0; index < arrayDocumentos.length; index++) {
          const element = arrayDocumentos[index];
          try {
            this.createusuarioForm.controls.documentos
              .get(element)
              .setValue(true);
          } catch (error) {}
        }
      }
    }
  }

  uploadFile(event) {
    this.file = event.target.files[0];
    let files = event.target.files;
    let numb = this.file.name.lastIndexOf(".");
    if (files.length === 0) return;
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    };
  }

  onSubmit() {
    let myUser: any = {
      nombre: this.createusuarioForm.controls.nombre.value,
      read_only: this.createusuarioForm.get("read_only").value,
      eliminado: this.createusuarioForm.get("eliminado").value,
      password: this.createusuarioForm.controls.password.value,
      role: this.createusuarioForm.controls.role.value,
      documentos: "articulos_proveedor",
    };

    if (this.update) {
      myUser["id"] = this.paramId;

      if (this.file == null || this.file == undefined) {
        this.usuarioService.updateUserFile(myUser, this.file).subscribe(
          (resp) => {
            //console.log(resp);
            this.messageService.add({
              severity: "success",
              summary: "Registro",
              detail: "Registro Actualizado Correctamente",
            });

            setTimeout(() => {
              this.listaUsuarios();
            }, 1000);
          },
          (error) => {
            console.log("error", error);
          }
        );
      } else {
        this.usuarioService.updateUserFile(myUser, this.file).subscribe(
          (resp) => {
            console.log(resp);
            this.messageService.add({
              severity: "success",
              summary: "Registro",
              detail: "Registro Actualizado Correctamente",
            });
            setTimeout(() => {
              this.listaUsuarios();
            }, 1000);
          },
          (error) => {
            console.log("error", error);
          }
        );
      }
    } else {
      this.usuarioService.createUserFile(myUser, this.file).subscribe(
        (resp) => {
          console.log(resp);
          this.messageService.add({
            severity: "success",
            summary: "Registro",
            detail: "Registro guardado correctamente",
          });
          setTimeout(this.listaUsuarios.bind(this), 1000);
        },
        (error) => {
          console.log("error create user", error);
        }
      );
    }
  }

  listaUsuarios() {
    this.router.navigate(["dashboard/usuarios"]);
  }

  fecha() {
    let today = new Date();
    return today;
    let dd = today.getDate();
    let DD = "";
    var mm = today.getMonth() + 1; //January is 0!
    let MM = "";
    var yyyy = today.getFullYear();
    if (mm < 10) {
      MM = "0" + mm;
    } else {
      MM = "" + mm;
    }
    if (dd < 10) {
      DD = "0" + dd;
    } else {
      DD = "" + dd;
    }

    let myfecha = MM + "/" + DD + "/" + yyyy;
    myfecha = yyyy + "-" + MM + "-" + DD;
    console.log(myfecha);
    return myfecha;
  }
  regresar() {
    this.location.back();
  }
}
